<template>
  <div id="container" class="container spiele_start">
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <div class="fullscreen_background z1 active">
        <img src="/static/assets/spiele_memory/Hintergrund_2860.png" />
    </div>

    <div to="/spielememory" class="z2 active memo_01" @click="spielememory"><img src="/static/assets/spiele_start/spiele_start_hugidubies_memo.png"></div>
    <div to="/spielememory" class="z2 active memo_02" @click="spielememory"><img src="/static/assets/spiele_start/spiele_start_karten.png"></div>
    <div to="/spieledownloads" class="z3 active malen_01" @click="spieledownloads"><img src="/static/assets/spiele_start/spiele_start_hugidubies_ausmalbilder.png"></div>
    <div to="/spieledownloads" class="z3 active malen_02" @click="spieledownloads"><img src="/static/assets/spiele_start/spiele_start_stifte.png"></div>

  </div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Spiele',
  data () {
    return {
      who: 'Spiele'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright
  },
  methods: {
      spielememory () {
        var muted = (typeof window.muted === 'undefined' ? false : window.muted)  
        if (typeof window.currentAudio !== 'undefined') {
          try {
            window.currentAudio.pause()
            window.currentAudio.currentTime = 0
            window.currentAudio = null
          } catch(e) {
              console.log('pause geht nicht')
          }
        }
        window.currentAudio = new Audio('/static/assets/sounds/03_Spiele-Seite/Sprache/Hugidubies_Memo.mp3')
        window.currentAudio.muted = muted
        window.currentAudio.play()
        var self = this
        setTimeout(function () {
            self.$root.$router.push('/spielememory')
        }, 2000)
      },
      spieledownloads () {
        if (typeof window.currentAudio !== 'undefined') {
          try {
            window.currentAudio.pause()
            window.currentAudio.currentTime = 0
            window.currentAudio = null
          } catch(e) {
              console.log('pause geht nicht')
          }
        }
        var muted = (typeof this.$root.muted !== 'undefined' ? this.$root.muted : false)
        window.currentAudio = new Audio('/static/assets/sounds/03_Spiele-Seite/Sprache/Hugidubies_Ausmalbilder.mp3')
        window.currentAudio.muted = muted
        window.currentAudio.play()
        var self = this
        setTimeout(function () {
            self.$root.$router.push('/spieledownloads_gigi_07')
        }, 3000)
      }
  },
  mounted () {
    this.$ga.page(this.$router)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
      window.hintergrundSound.pause()
    } catch (e) {}
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* SPIELE */
.spiele_start .memo_01 {
    bottom: 14.5%;
    left: 21%;
}
.spiele_start .memo_01 {animation: memo_01_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes memo_01_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.spiele_start .memo_02 {
    bottom: 30%;
    left: 17%;
}
.spiele_start .memo_02 {animation: memo_02_erscheint 1s ease-out; animation-delay: 0s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes memo_02_erscheint {
    0% { transform: scale(0.5); opacity:0;}
    50% { transform: scale(0.5); opacity:0;}
    80% { transform: scale(1.1); opacity:1;}
    100% { transform: scale(1); opacity:1;}
}
.copyright {
    width: 500px !important;
}
.spiele_start .malen_01 {
    bottom: 14.5%;
    right: 22.5%;
}
.spiele_start .malen_01 {animation: malen_01_erscheint 0.5s ease-out; animation-delay: 2s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes malen_01_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.spiele_start .malen_02 {
    bottom: 30%;
    left: 60%;
}
.spiele_start .malen_02 {animation: malen_02_erscheint 1s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes malen_02_erscheint {
    0% { transform: scale(0.5); opacity:0;}
    50% { transform: scale(0.5); opacity:0;}
    80% { transform: scale(1.1); opacity:1;}
    100% { transform: scale(1); opacity:1;}
}
.spiele_start div {
    position: absolute;
    width: 286px;
}
.spiele_start div{display:none;}
.spiele_start .active{display:block !important;}
.spiele_start #spiele_start{position: absolute; width: 1920px; height: 1080px;}
.logo, .menu{display:inherit !important;}
area, .lautsprecher, .restart, .karte_bottom_01, .karte_bottom_02, .karte_bottom_03, .minuten_01, .minuten_02, .memo_01, .memo_02, .malen_01, .malen_02 {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Spiele.vue